/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ProcessExecutionBase } from "../../../../schema/generated/ProcessExecution";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ProcessExecutionDataApi extends EntityDataApi<ProcessExecutionBase> {
  public readonly def = idbEntityDefs.ProcessExecution;
}